import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InventoryIdenty, Estados, StateViewer } from '../../../core/model/inventories';
import { AzDetail } from '../../../core/model/inventory-detail/az-detail';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { UtcDatePipe } from '../../../core/pipes/utc-date-pipe';

@Component({
  selector: 'app-az-viewer',
  templateUrl: './az-viewer.component.html',
  styleUrls: ['./az-viewer.component.css']
})
export class AzViewerComponent implements OnInit {

  @Input() isInventoryView: boolean;
  az: AzDetail;
  @Input() set azBasico(_az: AzDetail) {
    if (!_az.estadosViewer) {
      _az.estadosViewer = this.getEstadosViewer((_az.estado as Estados));
    }
    if (!_az.fieldsToShow) {
      _az.fieldsToShow = this.getFieldsToShow(_az);
    }

    this.az = _az;
   }
  @Input() inventoryLevel: number;

  @Output() editObsPartialEvent = new EventEmitter<InventoryIdenty>();
  @Output() removeRecord = new EventEmitter<InventoryIdenty>();
  @Output() createLoanEvent = new EventEmitter<InventoryIdenty>();
  @Output() openObsPartialModalEvent = new EventEmitter<InventoryIdenty>();

  constructor(private translateService: TranslateService,
                private datePipe: DatePipe,
                private utcPipe: UtcDatePipe) { }

  ngOnInit() {
  }

  tieneObsParcial(): any {
    return this.az.shoppingCart && this.az.shoppingCart.obsPartial;
  }

  editObsPartial() {
    this.editObsPartialEvent.emit(this.az);
  }

  createLoan() {
    this.createLoanEvent.emit(this.az);
  }

  openObsPartialModal() {
    this.openObsPartialModalEvent.emit(this.az);
  }

  remove() {
    this.removeRecord.emit(this.az);
  }

  private getEstadosViewer(estado: Estados): StateViewer[] {
    if (!estado) {
      return null;
    }
    let estadosViewer: StateViewer[] = [];
    estadosViewer = this.checkState(estadosViewer, estado, 'activo', 'fas fa-inbox', 'green');
    estadosViewer = this.checkState(estadosViewer, estado, 'pendiente_recepcion', 'fas fa-share-square fa-rotate-180', 'darkblue');
    estadosViewer = this.checkState(estadosViewer, estado, 'bloqueado', 'fas fa-lock', 'red');
    estadosViewer = this.checkState(estadosViewer, estado, 'expurgo_logico', 'fas fa-eraser', 'orange');
    estadosViewer = this.checkState(estadosViewer, estado, 'expurgo_fisico', 'fas fa-times', 'red');
    estadosViewer = this.checkState(estadosViewer, estado, 'baja', 'fas fa-arrow-alt-circle-down', 'red');
    estadosViewer = this.checkState(estadosViewer, estado, 'prestado', 'fas fa-sign-in-alt', 'blue');
    estadosViewer = this.checkState(estadosViewer, estado, 'transporte', 'fas fa-truck', 'blue');

    return estadosViewer;
  }
  private checkState(estadosViewer: StateViewer[], estado: Estados, nombre: string, iconClass: string, color: string): StateViewer[] {
    if (!!estado[nombre]) {
      const state: StateViewer = this.getStateViewer(estado, nombre, iconClass, color);
      estadosViewer.push(state);
    }
    return estadosViewer;
  }

  private getStateViewer(estado: Estados, nombre: string, iconClass: string, color: string): StateViewer {
    const text = this.translateService.instant(`inventory.state.${nombre}`);
    const date = this.datePipe.transform(this.utcPipe.transform(estado[nombre]), 'dd-MM-yyyy HH:mm:ss');
    const title = `${text}: ${date}`;
    return { name: nombre, iconClass: iconClass, color: color, title: title };
  }


  private getFieldsToShow(_az: AzDetail): { key: string; value: any; }[] {
    const id = this.getFieldToShow(this.translateService.instant('inventory.azFields.id'),
      _az.id);

    const idAz = this.getFieldToShow(this.translateService.instant('inventory.azFields.idAz'),
      _az.idAz);

    const idContenedor = this.getFieldToShow(this.translateService.instant('inventory.azFields.idContenedor'),
      _az.idContenedor);

    const idSerie = this.getFieldToShow(this.translateService.instant('inventory.azFields.idSerie'),
      _az.idSerie);

    const creationDate = this.getFieldToShow(this.translateService.instant('inventory.azFields.fechaCreacion'),
      this.datePipe.transform(this.utcPipe.transform(_az.fechaCreacion), 'dd-MM-yyyy'));

    const descripcion = this.getFieldToShow(this.translateService.instant('inventory.azFields.descripcion'),
      _az.descripcion);

    const fieldsToShow: { key: string; value: any; }[] = [
      id,
      idAz,
      idContenedor,
      idSerie,
      creationDate,
      descripcion
    ];
    return fieldsToShow;
  }

  private getFieldToShow(text: string, value: any): { key: string; value: any; } {
    return { key: text, value };
  }

}
